import { api } from '@services';

interface IAddTaskProducts {
  taskId: string;
  productsIds: string[];
}

const addTaskProducts = async ({
  taskId,
  productsIds,
}: IAddTaskProducts): Promise<void> => {
  await api.post(`/tasks/${taskId}/products`, { productsIds });
};

export { addTaskProducts };
